
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Zergling from '../../../helpers/zergling';
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import {t} from "../../../helpers/translator";
import KeyboardInput from "../InputKeyboard";
import { getSwarmSetRfidPinCodeRequest } from "../../../helpers/terminalRequests/rfid";

const DmsResetPinCode = ({ dispatch, isAdminLoggedIn, popupParams }) => {
    const [checkLoading, setCheckLoading] = useState(false);
    const [formErrored, setFormErrored] = useState(false);
    const [form, setForm] = useState({
        documentId: '',
    });

    const isFormValid = useMemo(() => form.documentId, [form]);
    const submitDisabled = useMemo(() => (
        !isFormValid ||
        !isAdminLoggedIn ||
        checkLoading ||
        !popupParams?.rfid
    ), [isFormValid, isAdminLoggedIn, checkLoading, popupParams]);

    const fieldChange = (name, value) => {
        formErrored && setFormErrored(false);
        setForm({
            ...form,
            [name]: value,
        });
    }

    const submit = async () => {
        if (submitDisabled) return;

        try {
            setCheckLoading(true);
            const token = JSON.parse(sessionStorage.getItem("authData")).token;
            const result = await Zergling.get({ token, filter: { rfid: popupParams?.rfid } }, 'terminal_find_player');

            if (!result?.data?.length) throw new Error();

            const docNumber = result?.data?.[0].DocNumber;
            if (docNumber !== form.documentId) {
                setForm({ ...form, documentId: '' });
                setFormErrored(true);
                setCheckLoading(false);
            } else {
                const params = {
                    PinCode: '0000',
                    Rfid: popupParams?.rfid,
                }
                await Zergling.get(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');
                dispatch(ClosePopup());
            }
        } catch {
            setForm({ ...form, documentId: '' });
            setFormErrored(true);
            setCheckLoading(false);
        }
    }

    return <div>
        <div className="title-popup-page-m-dms">
            <p className='auth-popup-title'>{t("Reset PIN Code")}</p>
            {!popupParams?.disable && <button className="popup-closed-b" onClick={() => dispatch(ClosePopup())} />}
        </div>
        <p className="popup-description">{t("Please input the Document ID")}</p>
        <div className="ticket-results-view-p">
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Code')}</p>
                            <div className="single-form-item">
                                <KeyboardInput numeric type='text' value={form.documentId} onChange={value => fieldChange('documentId', value)} />
                                {formErrored && <p className="field-is-not-correct">{t('Invalid Code')}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            {!isAdminLoggedIn && <p>{t("Please ask administrator for confirmation")}</p>}
            <div className="separator-box-buttons-m-wrap">
                <div className="separator-box-buttons-m">
                    <button className={`button-view-normal-m ${submitDisabled ? 'trans-m' : ''}`}
                            disabled={submitDisabled}
                            onClick={submit}>
                        {t("Submit")}
                    </button>
                </div>
                <div className="separator-box-buttons-m">
                    <button className="button-view-normal-m trans-m" onClick={() => dispatch(ClosePopup())}>
                        {t("Cancel")}
                    </button>
                </div>
            </div>
        </div>
    </div>;
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn,
            state => state.uiState.popupParams,
        ],
        (isAdminLoggedIn, popupParams) => {
            return {
                isAdminLoggedIn,
                popupParams
            };
        }
    );
};

export default connect(mapStateToProps)(DmsResetPinCode);